<template>
  <v-dialog v-model="bulkDeleteDialog" scrollable>
    <v-card>
      <v-card-title>Bulk Delete</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row no-gutters>
          <v-col class="d-flex">
            <v-col cols="4" sm="12" md="4">
              <v-menu
                ref="menuFrom"
                v-model="menuFrom"
                :close-on-content-click="false"
                :return-value.sync="dateFrom"
                transition="scale-transition"
                bottom
                right
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFrom"
                    label="From"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="date-field"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateFrom" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menuFrom = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menuFrom.save(dateFrom)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" sm="12" md="4">
              <v-menu
                ref="menuTo"
                v-model="menuTo"
                :close-on-content-click="false"
                :return-value.sync="dateTo"
                transition="scale-transition"
                bottom
                right
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateTo"
                    label="To"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="date-field"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateTo" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dateTo = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menuTo.save(dateTo)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" sm="12" md="4">
              <v-autocomplete
                v-model="HouseId"
                :items="houses"
                item-text="Name"
                item-value="_id"
                label="Programs"
                required
                multiple
                :error-messages="houseErrors"
                @input="$v.HouseId.$touch()"
                @blur="$v.HouseId.$touch()"
              ></v-autocomplete>
            </v-col>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              v-model="selectedShifts"
              :headers="headers"
              :items="shifts"
              item-key="shiftId"
              sort-asc
              show-select
              class="elevation-1"
              :loading="isLoading"
              loading-text="Loading Data"
              height="250"
            >
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-1 white--text"
          color="blue darken-1"
          text
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          class="ma-1 white--text"
          v-if="isSearch"
          color="blue darken-1"
          @click="searchDelete"
        >
          Search
        </v-btn>
        <v-btn
          class="ma-1 white--text"
          v-if="isDelete"
          color="green darken-1"
          @click="bulkDelete"
        >
          Delete
        </v-btn>
        <v-btn
          class="ma-1 white--text"
          v-if="isReset"
          color="blue darken-1"
          @click="resetDelete"
        >
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment_timezone from "moment-timezone";
import axios from "axios";
import { url } from "@/client_config/config";
import DateTimeUtil from "../../utils/date-time.util";

export default {
  props: {
    houses: Array,
  },
  mixins: [validationMixin],
  validations: {
    //StaffId: { required },
    HouseId: { required },
  },
  data() {
    return {
      dialog: false,
      menuFrom: false,
      menuTo: false,
      dateFrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateTo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      HouseId: "",
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "date",
        },
        { text: "Name", value: "name" },
        { text: "Status", value: "status" },
        { text: "Clocked In", value: "StartDate" },
        { text: "Clocked Out", value: "EndDate" },
        { text: "House", value: "HouseId" },
      ],
      shifts: [],
      isLoading: false,
      selectedShifts: [],
      isDelete: false,
      isSearch: true,
      isReset: false,
      // userPrograms: JSON.parse(localStorage.getItem("userPrograms") || "[]"),
      // userPrograms: props.houses,
      userState: localStorage.getItem("userState"),
      programIds: null,
    };
  },

  created() {
    console.log({ housesProps: this.houses });
  },

  computed: {
    bulkDeleteDialog: {
      get() {
        return this.$store.state.shifts.bulkDeleteDialog;
      },
      set(val) {
        this.$store.commit("shifts/SET_BULK_DELETE_DIALOG", val);
      },
    },
    houseErrors() {
      const errors = [];
      if (!this.$v.HouseId.$dirty) return errors;
      !this.$v.HouseId.required && errors.push("House/Unit is required");
      return errors;
    },
  },

  methods: {
    ...mapActions("shifts", ["getBulkDelete", "doBulkDelete"]),

    close() {
      this.bulkDeleteDialog = false;
      this.resetDelete();
    },

    resetDelete() {
      this.isSearch = true;
      this.isDelete = false;
      this.isReset = false;
      this.shifts = [];
      this.selectedShifts = [];
    },

    async searchDelete() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      this.isLoading = true;
      this.shifts = [];

      const startDate = DateTimeUtil.toUTCISOString(
        DateTimeUtil.toStartOfDay(this.dateFrom)
      );
      const endDate = DateTimeUtil.toUTCISOString(
        DateTimeUtil.toEndOfDay(this.dateTo)
      );
      const programIds = this.HouseId.join(",");

      const data = {
        DateFrom: new Date(startDate).toISOString(),
        DateTo: new Date(endDate).toISOString(),
        HouseId: programIds,
      };
      try {
        const res = await this.getBulkDelete(data);
        this.processShifts(res.data.shifts);
        this.isLoading = false;
        this.isSearch = res.data.shifts.length === 0;
        this.isDelete = res.data.shifts.length > 0;
        this.isReset = res.data.shifts.length > 0;
      } catch (error) {
        console.error(error);
        this.isLoading = false;
      }
    },

    async getProgramIds() {
      const params = {
        names: this.HouseId.join(","),
        state: this.userState,
      };

      try {
        const response = await axios.get(`${url}/units/program/ids`, {
          params,
        });
        this.programIds = response.data;
      } catch (error) {
        console.error("Failed to fetch program IDs:", error);
      }
    },

    processShifts(shifts) {
      shifts.forEach((value) => {
        const formattedShift = {
          ...value,
          shiftId: value._id,
          name: value.employee.Name,
          date: moment(value.StartDate).format("YYYY-MM-DD"),
          StartDate: moment(new Date(value.StartDate)).format("hh:mm A"),
          EndDate: moment(new Date(value.EndDate)).format("hh:mm A"),
          status: value.Status == "0" ? "Unpublished" : "Published",
          HouseId:
            (this.houses.find((house) => house._id === value.HouseId) || {})
              .Name || "",
        };
        this.shifts.push(formattedShift);
      });
    },

    bulkDelete() {
      const shiftID = [];

      if (this.selectedShifts.length == 0) {
        this.msg = true;
        this.text = "Please select Shift";
        this.color = "error";
        let emitValue = { msg: this.msg, text: this.text, color: this.color };
        this.$emit("bulkDelete", emitValue);
        return false;
      }

      this.selectedShifts.forEach((element) => {
        shiftID.push(element._id);
      });

      const data = {
        shiftID,
        tz: moment_timezone.tz.guess(),
      };

      this.doBulkDelete(data)
        .then((res) => {
          this.msg = true;
          this.text = res.data.message;
          this.color = "success";
          let emitValue = { msg: this.msg, text: this.text, color: this.color };
          this.$emit("bulkDelete", emitValue);
          this.bulkDeleteDialog = false;

          this.resetDelete();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.date-field >>> input {
  text-align: center !important;
}
</style>
